import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { PersonProductInterface } from '../../+models';
import { PersonProductsActions, PersonProductsActionTypes } from './person-product.actions';

export const NAME = 'personProducts';

export interface State extends EntityState<PersonProductInterface> {
  // additional entities state properties
  loaded: boolean;
  error?: any;
}

export const adapter: EntityAdapter<PersonProductInterface> = createEntityAdapter<PersonProductInterface>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  loaded: false,
});

export function reducer(state = initialState, action: PersonProductsActions): State {
  switch (action.type) {
    case PersonProductsActionTypes.AddPersonProduct: {
      return adapter.addOne(action.payload.personProduct, state);
    }

    case PersonProductsActionTypes.UpsertPersonProduct: {
      return adapter.upsertOne(action.payload.personProduct, state);
    }

    case PersonProductsActionTypes.AddPersonProducts: {
      return adapter.addMany(action.payload.personProducts, state);
    }

    case PersonProductsActionTypes.UpsertPersonProducts: {
      return adapter.upsertMany(action.payload.personProducts, state);
    }

    case PersonProductsActionTypes.UpdatePersonProduct: {
      return adapter.updateOne(action.payload.personProduct, state);
    }

    case PersonProductsActionTypes.UpdatePersonProducts: {
      return adapter.updateMany(action.payload.personProducts, state);
    }

    case PersonProductsActionTypes.DeletePersonProduct: {
      return adapter.removeOne(action.payload.id, state);
    }

    case PersonProductsActionTypes.DeletePersonProducts: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case PersonProductsActionTypes.PersonProductsLoaded: {
      return adapter.setAll(action.payload.personProducts, {
        ...state,
        loaded: true,
      });
    }

    case PersonProductsActionTypes.PersonProductsLoadError: {
      return { ...state, error: action.payload, loaded: false };
    }

    case PersonProductsActionTypes.ClearPersonProducts: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
